import {
  FullScreenLoaderMainStyles,
  FullScreenLoaderWrapperStyles,
} from '@/components/fullScreenLoader/styles/fullScreenLoader.styles.ts';
import { Box, CircularProgress, Container } from '@mui/material';
import React from 'react';

export const FullScreenLoader: React.FC = () => {
  return (
    <Container sx={FullScreenLoaderMainStyles}>
      <Box sx={FullScreenLoaderWrapperStyles}>
        <CircularProgress />
      </Box>
    </Container>
  );
};
